'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './business-directory.routes';

export class BusinessDirectoryComponent {
  constructor(BusinessService, dialogs, $state, Auth, DTOptionsBuilder, Config) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.dialogs = dialogs;
    this.$state = $state;
    this.BusinessService = BusinessService;

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Business Directory");

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('responsive', true)
      .withOption('order', [0, 'asc'])
      .withOption('buttons',[{
        extend: 'excel',
        title: 'Business Directory'
      },{
        extend: 'csv',
        title: 'Business Directory'
      },{
        title: 'Business Directory',
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'landscape',
        pageSize: 'LETTER'
      },'print']);

    this.isAdmin = Auth.isAdminSync;

    BusinessService.queryUserBusinesses(data => {
      this.data = data;
    });
  }

  createNewBusiness() {
    var dlg = this.dialogs.confirm(
      "Create new business?", "Do you want to add a new business?");
    dlg.result.then(() => {
      this.$state.go("business-profile-edit");
    }, () => {
      // Cancel
    });
  }

  deleteBusiness(business) {
    var that = this;

    var busText = "<br/><br/><b>" + business.name + "</b>";

    var dlg = this.dialogs.confirm("Delete Business Profile?", "Do you really want to delete this business profile?" + busText);
    dlg.result.then(() => {
      // OK delete it
      that.BusinessService.delete({id: business._id},
        () => {
          that.data = that.data.filter(function( obj ) {
            return obj._id !== business._id;
          });
        },
        err => {
          alert("Could not delete business profile");
        });
    }, () => {
      // Cancel
    });
  }
}

export default angular.module('conduuApp.businessDirectory', [uiRouter])
  .config(routes)
  .component('businessDirectory', {
    template: require('./business-directory.html'),
    controller: BusinessDirectoryComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/directories/business/business-directory.component.js